import { useParams } from 'react-router-dom'

import { useLinkageApiKeyGetApi } from '@/common/api/modules/linkageApiKey'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import LinkageApiKeyEditPage from '@/components/container/page/admin/linkageApiKey/LinkageApiKeyEditPage'

const LinkageApiKeyUpdatePage = () => {
  const { linkageApiKeyId } = useParams()

  const { data, error, mutate } = useLinkageApiKeyGetApi({
    linkage_api_key_id: Number(linkageApiKeyId)
  })

  return (
    <DetailPageLoader error={error} data={data} small>
      <LinkageApiKeyEditPage linkageApiKey={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default LinkageApiKeyUpdatePage
